import AppLocale from "../../languageProvider/index";
import englishFlag from "../../image/flag/uk.svg";
import spanishFlag from "../../image/flag/spain.svg";
import portugalFlag from "../../image/flag/portugal.svg";
import brasilFlag from "../../image/flag/brasil.svg";

const getDefaultLanguage = () => {
    
    if (window.navigator.language.includes(AppLocale.US.code)) {
        return "english";
    }
    if (window.navigator.language.includes(AppLocale.ES.code)) {
        return "spanish";
    }
    if (window.navigator.language.includes(AppLocale.PT.code)) {
        return "portuguese";
    }
    if (window.navigator.language.includes(AppLocale.BR.code)) {
        return "portuguesBR";
    }
    else
        return "portuguesBR";;
}

const config = {
    defaultLanguage: getDefaultLanguage(),
    options: [
        {
            languageId: 'english',
            locale: 'en',
            code: 'US',
            text: 'English',
            icon: englishFlag,
            fullObj: AppLocale.US
        },
        {
            languageId: 'spanish',
            locale: 'es',
            code: 'ES',
            text: 'Espanol',
            icon: spanishFlag,
            fullObj: AppLocale.ES
        },
        {
            languageId: 'portuguese',
            locale: 'pt',
            code: 'PT',
            text: 'Português',
            icon: portugalFlag,
            fullObj: AppLocale.PT
        },
        {
            languageId: 'portuguesBR',
            locale: 'pt',
            code: 'BR',
            text: 'Português Brasil',
            icon: brasilFlag,
            fullObj: AppLocale.BR
        }
    ]
}

export function getCurrentLanguage(lang) {
    const selectedLanguage = config.options.find(xLang => xLang.languageId === lang);
    const defaultLanguage = config.options.find(lang => lang.languageId === getDefaultLanguage())

    return selectedLanguage || defaultLanguage;
}

export default config;